import React, { useState, useEffect } from 'react';
import { Container, Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import EirInformation from '../eir-information/EirInformation';
import CrossSellInitiateCard from './CrossSellInitiateCard';

const CrossSellInitiateContainer = ({
  setCrossSellCardState,
  data,
  setOfferCardButtonDisable,
  CSFailed,
}) => {
  const theme = useTheme();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data) {
      setCards([
        {
          img: data.CSInitImg.path,
          altText: data.CSInitImg.description,
          containerTitle: data.CSInitTitleDesc.title,
          containerDescription: data.CSInitTitleDesc.description,
          bodyTitle: data.CSBodyTitleDesc.title,
          bodyDescription: data.CSBodyTitleDesc.description,
          ctaText: data.CSInitCTA.title,
        },
      ]);
      setLoading(false);
    }
  }, [data]);
  return (
    <Container
      sx={{
        p: 0,
        mb: 2,
        display: { sm: 'flex', md: 'flex' },
        flexDirection: { sm: 'column', md: 'column' },
        alignItems: { sm: 'center', md: 'center' },
        justifyContent: { sm: 'center', md: 'center' },
      }}
      maxWidth='lg'
    >
      <Box>
        <EirInformation
          title={cards[0]?.containerTitle}
          description={cards[0]?.containerDescription}
          style={{
            title: styles(theme).title,
            discription: { color: theme.palette.primary.textColor3 },
          }}
        />
      </Box>
      <Grid container xs={12} sx={{ justifyContent: 'center', mt: '1rem', gap: '2rem', ml: 0 }}>
        {cards.length > 0 &&
          cards.map(info => (
            <CrossSellInitiateCard
              card={info}
              loading={loading}
              setCrossSellCardState={setCrossSellCardState}
              setOfferCardButtonDisable={setOfferCardButtonDisable}
              CSFailed={CSFailed}
            />
          ))}
      </Grid>
    </Container>
  );
};

export default CrossSellInitiateContainer;
